export const tabListMobile = [
  {
    name: 'netAddons',
    key: 'net-dodaci'
  },
  {
    name: 'callsAddons',
    key: 'poziv-dodaci'
  },
  {
    name: 'roamingAddons',
    key: 'roming-dodaci'
  },
  {

    name: 'smsAddons',
    key: 'sms-dodaci'
  }
]

export const tabListTv = [
  {
    name: 'tvAddons',
    key: 'commerce-tv-dodati'
  }
]

export const tabListBox = [
  {
    name: 'tvAddons',
    key: 'commerce-tv-dodati'
  },
  {
    name: 'netAddons',
    key: 'net-dodaci'
  },
  {
    name: 'callsAddons',
    key: 'poziv-dodaci'
  },
  {

    name: 'smsAddons',
    key: 'sms-dodaci'
  }
]

export const tabListOtherRoaming = [
  {
    name: 'otherRoaming',
    key: 'ostali-roming'
  }
]

export const tabListMRoaming = [
  {
    name: 'mRoaming',
    key: 'data-roming'
  }
]

export const tabListMSat = [
  {
    name: 'mSat',
    key: 'msat-tv-dodaci'
  }
]

export const addonTypes = {
  tv: 'TV',
  mobile: 'MOBILE',
  box: 'BOX',
  dataRoaming: 'OTHER ROAMING',
  mRoaming: 'MROAMING',
  mSat: 'MSAT'
}
